"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asyncLeadingWindow = asyncLeadingWindow;
exports.default = void 0;

var _asyncIterable = require("../../internal/async-iterable");

var _circularBuffer = require("../../internal/circular-buffer");

var _asyncConcat = require("../$concat/async-concat");

var _repeatTimes = require("../repeat-times/repeat-times");

async function* asyncLeadingWindow(source, size, {
  filler
} = {}) {
  const buffer = new _circularBuffer.CircularBuffer(size);
  const bufferReadProxy = new _circularBuffer.ReadOnlyCircularBuffer(buffer);
  buffer.fill(filler);
  let index = 0;

  for await (const item of (0, _asyncConcat.asyncConcat)(source, (0, _repeatTimes.repeatTimes)(size - 1, filler))) {
    buffer.push(item);

    if (index + 1 >= size) {
      yield bufferReadProxy;
    }

    index++;
  }
}

var _default = (0, _asyncIterable.asyncIterableCurry)(asyncLeadingWindow, {
  minArgs: 1,
  maxArgs: 2,
  optionalArgsAtEnd: true,

  validateArgs(args) {
    if (args[0] && typeof args[0] === 'object') {
      const {
        filler,
        size
      } = args[0];

      if (size !== undefined && args[1] !== undefined) {
        throw new Error('size cannot be specified as both a positional and named argument to leadingWindow');
      }

      args[0] = size;
      args[1] = {
        filler
      };
    }
  }

});

exports.default = _default;